import { useUserPermission } from "@helpers/userPermissionHelper";
import { NavItems } from "../../../common/helpers/navigation";
import { AdminNavItem } from "../../admin/components/manageNavItem";

export const SuperNav = (): JSX.Element => {
    const { isClinicalAdmin, isFacilitator } = useUserPermission({});

    const navItems: any[] = [];

    if (isClinicalAdmin || isFacilitator) {
        navItems.push({ item: NavItems.SuperAdmin.Organizations });
        navItems.push({ item: NavItems.SuperAdmin.WordSuggestions });
    }

    return (
        <div className="tabs is-boxed px-5 has-background-primary-dark is-size-7 has-text-weight-medium">
            <ul>
                {navItems.map((x, i) => (
                    <AdminNavItem key={`manage-nav-item-${i}`} item={x.item} itemCount={x.itemCount} />
                ))}
            </ul>
        </div>
    );
};
